import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// router setup
import routes from "./routes";
import store from '@/store';

// configure router
const router = new VueRouter({
  mode: "history",
  routes, // short for routes: routes
  scrollBehavior: to => {
    if (to.hash) {
      return {selector: to.hash};
    } else {
      return {x: 0, y: 0};
    }
  },
  linkExactActiveClass: "nav-item active"
});

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware)
    return context.next;

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({...context, next: nextMiddleware});
  };
}

router.beforeEach((to, from, next) => {

  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];
    const context = {from, next, to, router};
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({...context, next: nextMiddleware});
  }

  return next();
});

async function checkUserRole(to, from, next) {

  await store.dispatch("profile/role");
  return  store.getters["profile/role"];
}

async function checkUserOrderPage(to, from, next) {

  await store.dispatch("profile/order_page");
  return  store.getters["profile/order_page"];
}

router.beforeEach((to, from, next) => {

  if (from.path === '/login') {
    checkUserRole(to, from, next).then(role => {
      let toRedirect = '';
      checkUserOrderPage(to, from, next).then(order_page =>{
        switch (role) {
          case "retoucher":
            toRedirect = 'new_mvp/order-new-idle-time';
            break;
          case "pro-retoucher":
            toRedirect = 'new_mvp/orderCheck';
            break;
          case "senior-retoucher":
            toRedirect = 'new_mvp/seniorRetoucherOrderCheck';
            break;
          case "junior-retoucher":
            toRedirect = 'new_mvp/juniorRetoucherOrder';
            break;
          default:
            toRedirect = 'user-profile';
            break;
        }
        return next({path: toRedirect});
      })
    });
  }

  if (['/new_mvp/order','/new_mvp/order-func-based','/new_mvp/order-new-prostoy'].indexOf(to.path) > -1 ) {
      let toRedirect = 'new_mvp/order-new-idle-time';
      return next({path: toRedirect});
  }

  return next();
});

export default router;
